<div>
  <dgx-data-search
    [placeholder]="i18n.Core_Search"
    [searchTerm]="searchTerm"
    type="short"
    (doSearch)="onSearchSubmit($event)"
  ></dgx-data-search>
</div>
